import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DashboardTabStore {
    private readonly url = signal('/sites');

    readonly lastTabUrl = this.url.asReadonly();

    visit(url: string): void {
        this.url.set(url);
    }
}
